export type ResourceState = 'uninitialized' | 'loading' | 'loaded' | 'error';

export interface UninitializedResource {
  state: 'uninitialized';
}

export interface LoadingResource {
  state: 'loading';
}

export interface LoadedResource<T> {
  state: 'loaded';
  data: T;
}

export interface ErrorResource {
  state: 'error';
  error: Error;
}

export type ExternalResource<T> =
  | UninitializedResource
  | LoadingResource
  | LoadedResource<T>
  | ErrorResource;

export const createUninitializedResource = (): UninitializedResource => ({
  state: 'uninitialized',
});

export const createLoadingResource = (): LoadingResource => ({
  state: 'loading',
});

export const createLoadedResource = <T>(data: T): LoadedResource<T> => ({
  state: 'loaded',
  data,
});

export const createErrorResource = (error: Error): ErrorResource => ({
  state: 'error',
  error,
});

export function isUninitialized<T>(
  resource: ExternalResource<T>,
): resource is UninitializedResource {
  return resource.state === 'uninitialized';
}

export function isLoading<T>(resource: ExternalResource<T>): resource is LoadingResource {
  return resource.state === 'loading';
}

export function isLoaded<T>(resource: ExternalResource<T>): resource is LoadedResource<T> {
  return resource.state === 'loaded';
}

export function isError<T>(resource: ExternalResource<T>): resource is ErrorResource {
  return resource.state === 'error';
}
